'use strict';

// Bindings are written with lodash set, so only these paths are allowed (blocks __proto__ and friends).
const PRICE_TAG_BINDING_PATTERN = /^(tiers\[[0-9]\]\.(globalRewards|globalRequirements|productOfferGroups\[[0-9]\]\.(rewards|requirements))\[[0-9]\]\.amount|displayValues\.[a-zA-Z]{1,40}|customerAvailability|maximumPerPurchase)$/;

const DISPLAY_VALUES_PREFIX = 'displayValues.';

const isAllowedPriceTagBinding = binding =>
    typeof binding === 'string' && PRICE_TAG_BINDING_PATTERN.test(binding);

const isDisplayValueBinding = binding => binding.startsWith(DISPLAY_VALUES_PREFIX);

const getDisplayValueKey = binding => binding.slice(DISPLAY_VALUES_PREFIX.length);

module.exports = {
    PRICE_TAG_BINDING_PATTERN,
    isAllowedPriceTagBinding,
    isDisplayValueBinding,
    getDisplayValueKey,
};
